(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tacview', {
            parent: 'account',
            url: '/tac-view',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/entities/tac-view/tac-view.html',
                    controller: 'TacViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })

                
    }
})();